import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/store/auth.store";

/**
 * Hook to sync user's locale preference with i18n
 * Use this in your App or root component
 */
export const useLocaleSync = () => {
  const { i18n } = useTranslation();
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (user?.locale && user.locale !== i18n.language) {
      i18n.changeLanguage(user.locale);
    }
  }, [user?.locale, i18n]);
};

/**
 * Sync locale imperatively (for use after login)
 */
export const syncLocale = (locale) => {
  if (locale) {
    import("i18next").then((i18n) => {
      i18n.default.changeLanguage(locale);
    });
  }
};

export default useLocaleSync;
